const finnish = {
  Common: {
    money: '{{amount, currency}}',
    moneyWithTrailingZeros: '{{amount, currency(displayTrailingZeros: true)}}',
    moneyWithoutDecimals: '{{amount, currency(displayDecimals: false)}}',
    back: 'Takaisin',
    close: 'Sulje',
    loading: 'Ladataan',
    otpInputLabel: 'Vahvistuskoodi',
  },
  Metadata: {
    title: 'Fairlo: Fair Finance',
    description: 'Arjen luottoratkaisu, joka auttaa tilanteesi muuttuessa. Hae luottoa jo tänään!',
  },
  Header: {
    openMenu: 'Avaa valikko',
    closeMenu: 'Sulje valikko',
    cookieSettings: 'Evästeasetukset',
    paymentPlan: 'Oma maksusuunnitelma',
    userProfile: 'Omat tiedot',
    home: 'Aloitussivu',
    logout: 'Kirjaudu ulos',
    login: 'Kirjaudu sisään',
  },
  FormErrors: {
    required: 'Vaadittu',
  },
  ErrorInfo: {
    title: 'Hups! Jokin meni vikaan',
    text: 'Palaa etusivulle ja yritä uudelleen',
    button: 'Siirry etusivulle',
  },
  ErrorToast: {
    defaultMessage:
      'Hups, jokin meni vikaan. Yritä uudelleen. Jos ongelma toistuu, ota yhteyttä tähän osoitteeseen: asiakaspalvelu@vauraus.fairlo.fi',
  },
  ApiErrors: {
    somethingWentWrong:
      'Hups, jokin meni vikaan. Yritä uudelleen. Jos ongelma toistuu, ota yhteyttä tähän osoitteeseen: asiakaspalvelu@vauraus.fairlo.fi',
    inactivity:
      'Hups, sinut kirjattiin ulos käyttämättömyyden vuoksi, kirjaudu uudelleen sisään jatkaaksesi. Jos ongelma jatkuu, ota yhteyttä osoitteeseen asiakaspalvelu@vauraus.fairlo.fi ',
  },
  Login: {
    title: 'Kirjaudu sisään Omat sivut -osioon',
    button: 'Kirjaudu sisään',
    invalidNationalNumber: 'Virheellinen kansallinen numero',
  },
  LoginFail: {
    abortMessage: 'Näyttää siltä, että keskeytit kirjautumisen. Yritä uudelleen..',
  },
  LoginFailNoAccount: {
    title: 'Sinulla ei ole aktiivista Vauraus powered by Fairlo -tiliä.',
    body: 'Tämä voi johtua siitä, että olet lopettanut palvelun, sitä ei ole myönnetty tai se on päättynyt maksamattomien laskujen vuoksi. Mutta älä huoli, ongelma on helppo korjata. Napsauta alla olevaa painiketta ja tee uusi hakemus.',
    button: 'Tee hakemus',
  },
  Credit: {
    deposit: 'Ylimääräinen lyhennys',
    monthlyPayment: 'Muuta kuukausierää',
    withdrawal: 'Nosto',
    whatDoYouWantToDo: 'Mitä haluat tehdä?',
  },
  ProductSummaryCard: {
    availableLimit: 'Käytettävissä',
    creditLimit: 'Luottoraja',
    outstandingBalance: 'Luottosaldo',
    used: 'Luottosaldo',
    monthlyAmountLabel: 'Kuukausierä',
    monthlyAmountValuePositive: '{{amount, currency}} / {{period}} kk',
    interestRate: 'Vuosittainen korko',
  },
  RepaymentSummaryCard: {
    nextRepayment: 'Seuraava maksu',
    currentRepayment: 'Jatkuva takaisinmaksu',
    ongoing: 'käynnissä',
    nextRepaymentDate: 'on {{date, datetime(month: short; day: numeric)}}',
  },
  Modal: {
    ConfirmWithdrawal: {
      title: 'Haluatko vahvistaa {{withdrawalAmount, currency}}:n noston?',
      info: 'Siirretään palveluun yhdistetylle tilillesi.',
      infoWithFees:
        'Tässä on päivitetty kuukausieräsi sekä uusi jäljellä oleva velkasumma, joka sisältää {{setupFee, currency}} kruunun avausmaksun ja {{withdrawalFee, currency}} kruunun nostomaksun.',
      infoTitle1: 'Kuukausimaksu {{numberOfInstallments}} kk',
      infoTitle2: 'Uusi luottosaldo',
      button: 'Nosta {{withdrawalAmount, currency}}',
    },
    WithdrawalBlocked: {
      title: '<private>{{username}}</private>, valitettavasti et voi tehdä nostoja tällä hetkellä.',
      info: 'Fairlo suhtautuu vastuulliseen luotonantoon vakavasti, ja arvioimme, että ei olisi vastuullista sallia lisää nostoja. Emme voi tällä hetkellä tietää, milloin voit jälleen tehdä nostoja, mutta lupaamme ilmoittaa sinulle heti, kun tilanne muuttuu. Siihen asti on erittäin tärkeää, että noudatat maksusuunnitelmaasi. Ystäväsi Fairlossa',
      contactUs: 'Ota yhteyttä asiakaspalveluun',
      clear: 'OK',
    },
    WithdrawalAmountInvalid: {
      title: 'Väärä summa',
      info: 'Valitsemasi nostosumma ei ole enää käytettävissä. Valitse toinen summa.',
      clear: 'OK',
    },
    WithdrawalFail: {
      title: 'Siirto epäonnistui',
      info: 'Tapahtuma keskeytyi jostakin syystä. Yritä uudelleen. Jos ongelma toistuu, ota yhteyttä asiakaspalveluumme.',
      contactUs: 'Ota yhteyttä asiakaspalveluun',
      tryAgain: 'Yritä uudelleen',
    },
    WithdrawalInProgress: {
      title: 'Se on jo matkalla, mutta käsittely kestää hieman tavallista kauemmin.',
      info: 'Toisinaan käsittely voi kestää jopa 2 tuntia, mutta yleensä se sujuu paljon nopeammin. Ota rohkeasti yhteyttä, jos sinulla on kysyttävää.',
      clear: 'OK',
    },
    WithdrawalNotPossible: {
      title: 'Jäljellä oleva luottoraja on alle vähimmäisnoston',
      info: 'Nostoa varten tarvitset vähintään {{minimumWithdrawalAmount, currency}} käyttämätöntä luottoa.',
      button: 'OK',
    },
    WithdrawalSuccess: {
      title: 'Rahasi ovat tulossa',
      info: 'Katso täydellinen yhteenveto maksusuunnitelman näkymästä.',
      button: 'OK',
    },
    ChangeMonthlyPaymentSuccess: {
      title: 'Valmis. Sinulla on nyt uusi kuukausimaksu.',
      info: 'Alla näet uuden kuukausieräsi.',
      listItemTitle: 'Kuukausierä',
      numberOfInstallmentsLabel: 'Takaisinmaksuaika',
      numberOfInstallmentsValue: '{{count}} kk',
      button: 'Valmis',
    },
    ChangeMonthlyPaymentFailed: {
      title: 'Jokin meni pieleen',
      info: 'Kuukausierää ei voitu muuttaa.',
      button: 'OK',
    },
    ConfirmManualDeposit: {
      title: 'Nyt on sinun vuorosi!',
      info: 'Avoin saldosi päivittyy heti, kun olemme vastaanottaneet manuaalisen lisälyhennyksesi. Tilisiirron käsittely voi kestää jopa 5 arkipäivää.',
      button: 'OK',
    },
  },
  Withdrawal: {
    description: 'Valitse summa, jonka haluat nostaa valitsemallesi tilille.',
    desktopSliderTitle: "Valitse summa liu'uttamalla",
    withdrawAmount: 'Nosta {{amount, currency}}',
  },
  MonthlyPayment: {
    description: 'Valitse summa, jonka haluat maksaa takaisin kuukausittain.',
    desktopSliderTitle: "Valitse summa liu'uttamalla",
    changeMonthlyPaymentButton: 'Muuta tasolle {{amount, currency}} / kk',
  },
  ManualDeposit: {
    title: 'Ylimääräisen takaisinmaksun tiedot',
    description:
      'Sinun tulee tehdä pankkisiirto yhdistetyltä tililtäsi alla olevalle tilille. Tämä ei korvaa laskulla lähetettäviä kuukausittaisia takaisinmaksujasi. Maksun kirjautumisessa tilillesi voi kestää jopa 5 arkipäivää.',
    outstandingBalanceLabel: 'Avoin saldo',
    accountNameLabel: 'Tilinhaltijan nimi',
    ibanLabel: 'IBAN',
    paymentReferenceLabel: 'Viite',
    disclaimer: '(Vain siltä tililtä tulevat maksut hyväksytään, jolle nostot on maksettu)',
    confirmButton: 'OK',
    copyAccountName: 'Kopioi tilinhaltijan nimi',
    copyIban: 'Kopioi IBAN',
    copyPaymentReference: 'Kopioi viite',
  },
  Navigation: {
    deposit: 'Lisämaksu',
    monthlyPayment: 'Muuta kuukausimaksua',
    withdrawal: 'Nosto',
  },
  Products: {
    features: {
      spinWheel: 'Valitse summa pyöräyttämällä kiekkoa',
    },
    featureDetails: {
      setupFee: 'Aloitusmaksu {{amount, currency}}',
      withdrawalFee: 'Nostomaksu {{amount, currency}}',
      withdrawalFeeZero: 'Nostomaksu {{amount, currency}} (yleensä {{regularPrice, currency}})',
      principalLeftLabel: 'Uusi luottosaldo:',
      principalLeftDetails: '{{principalLeft, currency}}',
      principalLeftDetailsWithFees: '{{principalLeft, currency}} sisältäen kulut',
      monthlyRepaymentLabel: 'Uusi kuukausierä, korko {{percentage}}:',
      monthlyRepaymentDetails: '{{monthlyAmount, currency}} / {{period}} kk',
      totalRepayableLabel: 'Maksettavaa yhteensä:',
      infoText: 'Voit milloin tahansa vähentää korkokustannuksia muuttamalla kuukausierää',
    },
  },
  UserProfile: {
    title: 'Oma profiili',
    accountDetails: 'Omat tiedot',
  },
  AccountDetails: {
    title: 'Yhteystiedot',
    company: 'Yhtiö',
    email: 'Sähköpostiosoite',
    mobile: 'Matkapuhelin',
  },
  Transactions: {
    title: 'Maksusuunnitelma ja -historia',
    planTab: 'Suunnitelma',
    historyTab: 'Historia',
    noHistory: 'Historiatietoja ei ole',
    noPlanNewUser: 'Et ole käyttänyt luottoasi',
    noPlan: 'Tulevia maksuja ei ole',
    detailsTitle: 'Tapahtuma',
    transaction: {
      type: {
        DEPOSIT: 'Lisämaksu',
        WITHDRAW: 'Nosto',
        PAYBACK: 'Kuukausierä',
        SETUP_FEE: 'Aloitusmaksu',
      },
      product: {
        // Intentionally empty. Since FI only has one product, we don't want to show the product name.
        CREDIT: '',
      },
      status: {
        INCOMPLETE: 'Tuleva',
        COMPLETE: 'Maksettu',
        COMPLETE_DEPOSIT: 'Lisämaksu suoritettu',
        COMPLETE_WITHDRAW: 'Nosto tehty',
        CHARGE: 'Käynnissä',
        IN_EXTENDED_PAYMENT_PERIOD: 'Pidennetty maksuaika',
        OVERDUE: 'Erääntynyt',
      },
      detailType: {
        PRINCIPAL: 'Lyhennys',
        INTEREST: 'Korko',
        OVERDUE_INTEREST: 'Viivästyskorko',
        WITHDRAWAL_FEE: 'Nostomaksu',
        SETUP_FEE: 'Aloitusmaksu',
        INSTALLMENT_FEE: 'Kuukausimaksu',
        OVERDUE_FEE: 'Muistutusmaksu',
        DEBT_COLLECTION_FEE: 'Perintäkulut',
        DIRECT_DEBIT_MISSING_FEE: 'Katteettomuusmaksu',
        REMIT: 'Jälkilähetys',
        UNKNOWN: 'Tuntematon',
        TERMINATION: 'Irtisanominen',
        CAMPAIGN_DISCOUNT: 'Kampanja-alennus',
        CAPITALISED_COST: 'Maksamaton korko ja maksut lisätty saldoon',
        VAT: 'ALV {{rate}}',
      },
      feeRemoval: '{{feeType}} palautus',
      dueDate: 'Eräpäivä',
      completionDate: 'Maksupäivä',
      statusTitle: 'Tila',
      totalAmount: 'Yhteensä',
    },
  },
  ProductHomeShortcuts: {
    title: 'Pikavalinnat',
    transactionsTitle: 'Tapahtumahistoria',
    transactionsSubtitle: 'Kaikki maksut ja nostot yksityiskohtineen',
  },
  CreditHome: {
    title: '<private>{{username}}</private>',
    availableAmount: 'Voit nostaa',
    outOfCreditLimit: '{{amount, currency}}:sta',
    amountUsed: 'Käytetty luotto: {{amount, currency(displayDecimals: false)}}',
    amountUsedPrefix: 'Käytetty luotto: ',
    withdraw: 'Nosta rahaa',
    deposit: 'Maksa takaisin',
  },
  RepaymentCard: {
    toggleNextPaymentDetails: 'Näytä tai piilota seuraavan maksun tiedot',
    nextRepayment: 'Seuraava maksu: {{date, datetime(month: short; day: numeric)}}',
    debtFreeIn: 'Velaton noin {{count}} kuukauden kuluttua',
    changeMonthlyPaymentButtonShort: 'Muuta',
    leftToPay: 'Jäljellä maksettavaa: noin {{amount, currency}}',
    basedOnCurrentRepaymentPlan: '(Perustuu nykyiseen maksusuunnitelmaan)',
    paymentPlanButton: 'Näytä koko maksusuunnitelmani',
    changeMonthlyPaymentButton: 'Muuta kuukausisummaani',
    interest: '{{label}} ({{rate}})',
    principal: 'Velan lyhennys',
  },
} as const;

export default finnish;
